import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

import env from '../../env';

// Initialise firebase app
const fbApp = initializeApp({
  apiKey: env.apiKey,
  authDomain: env.authDomain,
  projectId: env.projectID,
});

// Initialise firebase modules
export const fbAuth = getAuth(fbApp);
